var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index",class:_vm.ism},[_c('pc',{class:_vm.ism,attrs:{"ism":_vm.ism}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }